
export const once = {
    once: true
};


let timeout_count = 1;
let delay;
let counter = 0;
let line_length;
let y_pos = 0;

$(function() {
    const videoSelector = '#' + sanitized_title + '-1.hero_video video';
    if ($(videoSelector).length > 0) {
        var my_video = $(videoSelector)[0];
        line_length = $('.hero_video .element_headline .line').length;

        let introTimeout = setTimeout(function() {
            console.log("Fallback: video canplaythrough Timeout erreicht");
            intro_animation();
        }, 3000); // 3 Sekunden Fallback

        my_video.addEventListener('canplaythrough', function canplaythroughlistener() {
            clearTimeout(introTimeout);
            intro_animation();
            console.log("video can play through");
        }, once);

        my_video.addEventListener('stalled', function canplaythroughlistener() {
            clearTimeout(introTimeout);
            intro_animation();
            console.log("video stalled");
        }, once);

    } else {
        setTimeout(() => {
            console.log("video not found");
            const loader = document.getElementById('loader');
            const slideshow = document.querySelector('.hero_slideshow[data-first-module="true"]');
            if (slideshow && loader) {
                const revealInfo = () => {
                    clearTimeout(revealTimeout);
                    loader.removeEventListener('transitionend', onLoaderHidden);
                    slideshow.classList.add('visible');
                };
                const onLoaderHidden = (event) => {
                    if (event.target === loader && event.propertyName === 'opacity') revealInfo();
                };
                // Also reveal when the loader has no transition or is already hidden.
                const revealTimeout = setTimeout(revealInfo, 750);
                loader.addEventListener('transitionend', onLoaderHidden);
            } else if (slideshow) {
                slideshow.classList.add('visible');
            }
            $('#loader').addClass("hidden");
        }, 1500);
    }
});


function intro_animation() {

    console.log("intro animation called");

    setTimeout(() => {

        $('#loader').addClass("hidden");

        $('#loader')[0].addEventListener('transitionend', function hero_intro_animation() {

            console.log("start hero animation");

            setTimeout(() => {

                $('.hero_video .element_headline .line').each(function show_line(idx) {

                    let line = $(this);
    
                    delay = 0.02 * idx;
                    y_pos = 3 * ( idx * 2 );
    
                    timeout_count = timeout_count + delay;
                    // console.log("timeout_count" + timeout_count);
    
                    var line_animation = gsap.fromTo(line, { y: y_pos, opacity: 0 }, { y: 0, opacity: 1, duration: 1.2, paused: false, ease: "none", delay: delay });
    
                    counter = counter + 1;
    
                    // console.log("counter "+ counter + " / " + line_length);
    
                    if (counter == line_length - 1) {
    
                        // console.log("pre last position");
    
                        setTimeout(() => {
    
                            // console.log("timeout "+timeout_count);
                            $('#main_header, #main_nav, .hero_video').addClass("visible");
    
                        }, timeout_count * 1000);
    
                    }
    
                });

            }, 500 );






        }, once);


    }, 1500);
}
